export default __webpack_public_path__ + "static/whiskymofo-logo-1a3dabdc4a92784e553f9f83cecb45cf.png";